import { jsx as _jsx } from "react/jsx-runtime";
import Typography from "@mui/material/Typography";
export const PaymentConfirmationStatus = () => {
    return _jsx(Typography, { children: "Confirmation complete. Please close this window to continue." });
};
